import WebsiteRoutes from "../apiRoutes/WebsiteRoutes";
import { GET, POST } from "./ConsumeApiController";


export async function GetData(uuid)
{
    let response = await GET(WebsiteRoutes.SmartCard.GetProfile+uuid);
    return response;
}